import { useEffect, useState } from 'react';
import { getCaroPatient } from '@frontend/services/api/patientsApiService';
import { useAbortSignal } from './useAbortSignal';
import { usePatientEpisodeCategoryContext } from './usePatientEpisodeCategoryContext';

export interface IUseGetCaroPatient {
    hasAccount: boolean;
    hasActivatedAccount: boolean;
    isLoading: boolean;
}

export function useGetCaroPatient(): IUseGetCaroPatient {
    const abortSignal = useAbortSignal();
    const { patient } = usePatientEpisodeCategoryContext();
    const [isLoading, setIsLoading] = useState(true);
    const [hasAccount, setHasAccount] = useState(false);
    const [hasActivatedAccount, setHasActivatedAccount] = useState(false);

    useEffect(() => {
        loadCaroPatient();
    }, [patient.id]);

    async function loadCaroPatient(): Promise<void> {
        const caroPatient = await getCaroPatient(patient.id, abortSignal);
        if (caroPatient) {
            setHasAccount(true);
            setHasActivatedAccount(caroPatient.firstLoginDateTime !== null);
        } else {
            setHasAccount(false);
            setHasActivatedAccount(false);
        }
        setIsLoading(false);
    }

    return { hasAccount, hasActivatedAccount, isLoading };
}
